import React from 'react';
import styled from 'styled-components';
import { WorkspacePanel, PanelHeader, PanelBody, DefGroup, ActionBar } from './CreditWorkspace';

const Layout = styled.div`
  display: flex; flex-direction: column; gap: 24px;
  color: #e2e8f0;
  > * { min-width: 0; }
  h2 { margin: 0 0 6px; font-size: 1.1rem; color: #f8fafc; }
  p { margin: 0; color: #94a3b8; font-size: .85rem; line-height: 1.6; }
  .sections { display: flex; flex-direction: column; gap: 24px; }
  .section { min-width: 0; }
  .section-heading { margin-bottom: 16px; }
  .actions { display: flex; flex-wrap: wrap; gap: 8px; margin: 16px 0; }
  .attention { display: flex; align-items: center; justify-content: space-between; gap: 24px; border-bottom: 1px solid #1e293b; padding-bottom: 16px; }
  .attention > div:first-child { flex: 1; }
  .attention .actions { margin: 0; }
  .servicing { display: flex; align-items: center; flex-wrap: wrap; gap: 20px; }
  .servicing h2 { margin: 0; font-size: .85rem; color: #94a3b8; }
  ${ActionBar} { flex-wrap: wrap; }
  && ${WorkspacePanel}, && ${DefGroup} { border: 0; border-radius: 0; background: transparent; box-shadow: none; }
  && ${WorkspacePanel} { border-top: 1px solid #1e293b; }
  && ${PanelHeader} { padding: 20px 0 12px; background: transparent; border: 0; }
  && ${PanelBody} { padding: 0; }
  && ${DefGroup} { padding: 0; }
  details { border-top: 1px solid #1e293b; padding-top: 18px; }
  summary { cursor: pointer; padding: 8px 0; font-weight: 600; }
  summary:focus-visible { outline: 2px solid #38bdf8; outline-offset: 4px; }
  @media(max-width: 900px) { .attention { align-items: flex-start; flex-direction: column; } }
`;

interface Props {
  children: React.ReactNode;
  attention: React.ReactNode;
  actions: React.ReactNode;
  followUp: React.ReactNode;
  arrangement?: React.ReactNode;
}

/** Composes existing loan evidence and actions without another level of navigation. */
export default function LoanOverviewWorkspace(p: Props) {
  return <Layout>
    <div className="attention" aria-label="Loan attention"><div>{p.attention}</div><div className="actions">{p.followUp}</div></div>
    <section className="servicing" aria-label="Loan servicing"><h2>Service this loan</h2>{p.actions}</section>
    <div className="sections">
      {p.children}
      {p.arrangement && <details><summary>Financing arrangement</summary>{p.arrangement}</details>}
    </div>
  </Layout>;
}
